import { SocketClient } from "cbcore-ts"
import { NO, UIButton, UIRoute, UITextView, UIView, UIViewController, YES } from "uicore-ts"
import { RHProcurement } from "../../prodModels"
import { CBButtonGroup } from "./Custom components/CBButtonGroup"
import { CBDialogViewShower } from "./Custom components/CBDialogViewShower"
import { RHButton } from "./Custom components/RH/RHButton"
import { RHCheckbox } from "./Custom components/RH/RHCheckbox"
import { RHColor } from "./Custom components/RH/RHColor"
import { RHRadioButton } from "./Custom components/RH/RHRadioButton"
import { RHTextArea } from "./Custom components/RH/RHTextArea"
import { RHTextField } from "./Custom components/RH/RHTextField"
import { NewProcurementPreviewViewController } from "./NewProcurementPreviewViewController"
import { WithNullsForOptional } from "./SocketClientFunctions"


export class NewProcurementViewController extends UIViewController {
    
    
    //#region Defining the views
    
    readonly titleLabel = new UITextView(
        this.view.elementID + "TitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "Uus hange"
    }).addedAsSubviewToView(this.view)
    
    
    newProcurementTypeButton = new RHRadioButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Hange hankelepingu sõlmimiseks" }
    })
    frameProcurementTypeButton = new RHRadioButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Hange raamlepingu sõlmimiseks" }
    })
    
    tiedProcurementTypeButton = new RHRadioButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Seotud hange " + "(tulekul)".bold() },
        enabled: NO
    })
    copyProcurementTypeButton = new RHRadioButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Kopeeri varasem hange " + "(tulekul)".bold() },
        enabled: NO
    })
    procurementTypeButtonGroup = new CBButtonGroup({
        "newProcurement": this.newProcurementTypeButton,
        "frameProcurement": this.frameProcurementTypeButton,
        "tiedProcurement": this.tiedProcurementTypeButton,
        "copyProcurement": this.copyProcurementTypeButton
    }).configuredWithObject({
        value: "newProcurement",
        selectionDidChange: (selectedButton: UIButton, value) => {
            
            // CBDialogViewShower.alert(selectedButton.titleLabel.text + value)
            
        }
    })
    
    procurementTitleLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({ text: "Hanke pealkiri" })
    procurementTitleTextField = new RHTextField().addedAsSubviewToView(this.view)
        .configuredWithObject({ placeholderText: "Sistesta hanke pealkiri" })
    
    
    generalProcurementInformationSectionTitleLabel = new UITextView(
        undefined,
        UITextView.type.header2
    ).configuredWithObject({
        text: "Hanke üldinfo"
    }).addedAsSubviewToView(this.view)
    
    procurementGeneralDescriptionTitleLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({ text: "Hanke lühikirjeldus" })
    procurementGeneralDescriptionTitleTextArea = new RHTextArea().addedAsSubviewToView(this.view)
        .configuredWithObject({ placeholderText: "Kirjelda hanget üldiselt" })
    
    
    durationSectionTitleLabel = new UITextView(
        this.view.elementID + "DurationTitleLabel",
        UITextView.type.header2
    ).configuredWithObject({
        text: "Hankelepingu kestus"
    }).addedAsSubviewToView(this.view)
    
    durationSpecifiedInDocsButton = new RHRadioButton()
        .addedAsSubviewToView(this.view)
        .configuredWithObject({
            titleLabel: { text: "Kaetakse alusdokumendis" }
        })
    durationInMonthsButton = new RHRadioButton()
        .addedAsSubviewToView(this.view)
        .configuredWithObject({
            titleLabel: { text: "Kestus kuudes" }
        })
    durationInDaysButton = new RHRadioButton()
        .addedAsSubviewToView(this.view)
        .configuredWithObject({
            titleLabel: { text: "Kestus päevades" }
        })
    durationAsDateRangeButton = new RHRadioButton()
        .addedAsSubviewToView(this.view)
        .configuredWithObject({
            titleLabel: { text: "Kuupäevade vahemik" }
        })
    contractDurationButtonGroup = new CBButtonGroup({
        "specifiedInDocs": this.durationSpecifiedInDocsButton,
        "durationInMonths": this.durationInMonthsButton,
        "durationInDays": this.durationInDaysButton,
        "dateRange": this.durationAsDateRangeButton
    }).configuredWithObject({
        value: "specifiedInDocs",
        selectionDidChange: (selectedButton: UIButton, value) => {
            // CBDialogViewShower.alert(selectedButton.titleLabel.text + value)
        }
    })
    
    
    cpvCodeTitleLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({ text: "CPV kood" })
    cpvCodeTextField = new RHTextField().addedAsSubviewToView(this.view)
        .configuredWithObject({ placeholderText: "Sistesta hanke pealkiri" })
    
    openCPVTreeButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Ava CPV puu" },
        controlEventTargetAccumulator: {
            // @ts-ignore
            PointerUpInside: {
                EnterDown: async (sender, event) => {
                    
                    alert("CPV tree open")
                    
                }
            }
        }
    })
    cpvTreeButtonExplanationLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({ text: "(Mugavam valik avastuslikuks otsimiseks)" })
    
    openListOfInvitedOfferersButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: { text: "Osalema kutsutavad ettevõtted" },
        controlEventTargetAccumulator: {
            // @ts-ignore
            PointerUpInside: {
                EnterDown: async (sender, event) => {
                    
                    alert("Osalema kutsutavad ettevõtted open")
                    
                }
            }
        }
    })
    listOfInvitedOfferersButtonExplanationLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({ text: "(Uus ja võimas tööriist)" })
    
    
    estimatedCostTitleLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({
            text: "Eeldatav maksumus (KM-ta). Kui summa on võrdne lihthanke piirmääraga või ületab seda, korralda hange Riigihangete registris. Piirmäärasid vaata siit."
        })
    estimatedCostTextField = new RHTextField().addedAsSubviewToView(this.view)
        .configuredWithObject({
            placeholderText: "Hanke eeldatav maksumus"
        })
    
    submissionDeadlineTitleLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({
            text: "Pakkumuse esitamise tähtpäev ja kellaaeg"
        })
    submissionDeadlineTextField = new RHTextField().addedAsSubviewToView(this.view)
        .configuredWithObject({
            placeholderText: "DD.MM.YYYY hh:mm"
        })
    
    
    autoExtendProcurementCheckbox = new RHCheckbox().addedAsSubviewToView(
            this.view)
        .configuredWithObject({
            titleLabel: { text: "Kui on alla" },
            selected: NO,
            controlEventTargetAccumulator: {
                SelectionChange: (sender, event) => {
                    
                    this.lessThanOffersTextField.enabled = this.autoExtendProcurementCheckbox.selected
                    this.extendDeadlineDaysTextField.enabled = this.autoExtendProcurementCheckbox.selected
                    
                }
            }
        })
    lessThanOffersTextField = new RHTextField().addedAsSubviewToView(this.view)
        .configuredWithObject({
            
            // viewHTMLElement: {
            //     setAttribute: [
            //         CALL("type", "number"),
            //         CALL("min", "0")
            //     ]
            // },
            type: "number",
            minValue: 1,
            validationRegex: new RegExp("^[1-9]\\d*$"),
            isRequired: YES,
            
            placeholderText: "",
            enabled: NO
        })
    autoExtendProcurementMiddleLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({
            text: "pakkumuse, pikenda hanget"
        })
    extendDeadlineDaysTextField = new RHTextField().addedAsSubviewToView(this.view)
        .configuredWithObject({
            
            // viewHTMLElement: {
            //     setAttribute: [
            //         CALL("type", "number"),
            //         CALL("min", "0")
            //     ]
            // },
            type: "number",
            minValue: 1,
            validationRegex: new RegExp("^[1-9]\\d*$"),
            isRequired: YES,
            
            placeholderText: "",
            enabled: NO
        })
    autoExtendProcurementEndLabel = new UITextView().addedAsSubviewToView(this.view)
        .configuredWithObject({
            text: "päeva võrra"
        })
    
    
    hankeosadSectionTitleLabel = new UITextView(
        undefined,
        UITextView.type.header2
    ).configuredWithObject({
        text: "Hankeosad"
    }).addedAsSubviewToView(this.view)
    
    hankeosadCheckbox = new RHCheckbox().addedAsSubviewToView(
        this.view
    ).configuredWithObject({
        titleLabel: { text: "Hange on jaotatud osadeks" },
        selected: NO
    })
    
    
    nextButton = new RHButton().addedAsSubviewToView(this.view).configuredWithObject({
        titleLabel: {
            text: "Hanke eelvaade >"
        },
        controlEventTargetAccumulator: {
            // @ts-ignore
            PointerUpInside: {
                EnterDown: async (sender, event) => {
                    
                    const updatedProcurement = await this.saveDraft()
                    
                    if (updatedProcurement) {
                        
                        UIRoute.currentRoute
                            .routeByRemovingComponentNamed(NewProcurementViewController.routeComponentName)
                            .routeWithViewControllerComponent(
                                NewProcurementPreviewViewController,
                                { id: updatedProcurement._id ?? "" }
                            ).apply()
                        
                    }
                    
                    
                }
            }
        }
    })
    
    //#endregion Defining the views
    
    static procurement?: WithNullsForOptional<Omit<Omit<RHProcurement, "procuringCompany">, "primaryProcuringUser">>
    
    
    constructor(view: UIView) {
        
        super(view)
        
        // Code for further setup if necessary
        
        this.view.configureWithObject({
            backgroundColor: RHColor.backgroundColor
        })
        
    }
    
    
    static override readonly routeComponentName = "new_procurement"
    static override readonly ParameterIdentifierName = {
        "id": "id"
    }
    
    
    async saveDraft() {
        
        const procurement: WithNullsForOptional<Omit<Omit<RHProcurement, "procuringCompany">, "primaryProcuringUser">> = {
            
            _id: this.class.procurement?._id, // allow update or create
            
            userSelectedFlow: this.procurementTypeButtonGroup.value,
            
            secondaryProcuringUsers: [],
            
            title: this.procurementTitleTextField.text || null,
            
            description: this.procurementGeneralDescriptionTitleTextArea.text || null,
            
            CPV: this.cpvCodeTextField.text || null,
            
            estimatedCost: this.estimatedCostTextField.text
                           ? Number(this.estimatedCostTextField.text)
                           : null,
            
            deadlineDate: this.submissionDeadlineTextField.text
                          ? new Date(this.submissionDeadlineTextField.text)
                          : null,
            
            minimumAcceptableNumberOfOffers: this.autoExtendProcurementCheckbox.selected
                                             ? Number(this.lessThanOffersTextField.text || 0)
                                             : null,
            
            // visibility / state
            numberOfDaysToExtendDeadlineByIfTooFewOffers: this.autoExtendProcurementCheckbox.selected
                                                          ? Number(this.extendDeadlineDaysTextField.text || 0)
                                                          : null,
            status: "DRAFT",
            hasBeenCancelled: false,
            
            // procurement type
            isVisibleToTenderers: false,
            
            // parts
            type: this.procurementTypeButtonGroup.value,
            
            // defaults that backend expects
            parts: this.hankeosadCheckbox.selected ? [] : null,
            selectedLanguages: ["Eesti"],
            
            allowUnregisteredTenderers: YES
        }
        
        // // persist locally so future saves update instead of create
        // this.class.procurement = procurement
        
        const savingResponse = (await SocketClient.AddOrModifyNewProcurement(procurement)).result
        
        if (savingResponse.procurement?._id) {
            
            UIRoute.currentRoute.routeBySettingParameterInComponent(
                NewProcurementViewController.routeComponentName,
                NewProcurementViewController.ParameterIdentifierName.id,
                savingResponse.procurement._id
            ).applyByReplacingCurrentRouteInHistory()
            
        }
        
        return savingResponse.procurement
        
    }
    
    override async viewWillAppear() {
        
        await super.viewWillAppear()
        
        await this.loadProcurementIfPossible()
        
        
    }
    
    private async loadProcurementIfPossible() {
        
        const procurementID = UIRoute.currentRoute.componentWithViewController(
            NewProcurementViewController)?.parameters.id
        
        if (procurementID) {
            
            try {
                
                const procurementData: RHProcurement = (await SocketClient.RetrieveProcurementPrivateInformation(
                    { id: procurementID }
                )).result
                
                // Populate the form with the loaded data
                this.procurementTypeButtonGroup.value = procurementData.userSelectedFlow || null
                this.procurementTitleTextField.text = procurementData.title || ""
                this.procurementGeneralDescriptionTitleTextArea.text = procurementData.description || ""
                this.cpvCodeTextField.text = procurementData.CPV || ""
                this.estimatedCostTextField.text = procurementData.estimatedCost?.toString() || ""
                this.submissionDeadlineTextField.text = procurementData.deadlineDate
                                                        ? new Date(procurementData.deadlineDate).toLocaleString("et-EE")
                                                        : ""
                
                if (procurementData.minimumAcceptableNumberOfOffers && procurementData.minimumAcceptableNumberOfOffers > 0) {
                    this.autoExtendProcurementCheckbox.selected = true
                    this.lessThanOffersTextField.text = procurementData.minimumAcceptableNumberOfOffers + ""
                    this.extendDeadlineDaysTextField.text = procurementData.numberOfDaysToExtendDeadlineByIfTooFewOffers?.toString() || ""
                }
                else {
                    this.autoExtendProcurementCheckbox.selected = false
                    this.lessThanOffersTextField.text = ""
                    this.extendDeadlineDaysTextField.text = ""
                }
                
                this.hankeosadCheckbox.selected = procurementData.parts !== null
                
                // Update static property for preview
                this.class.procurement = procurementData
                
            }
            catch (error) {
                
                this.clearAllFields()
                console.error("Failed to load procurement data:", error)
                CBDialogViewShower.alert("Hanke andmete laadimine ebaõnnestus.")
                
            }
            
        }
        else {
            
            this.clearAllFields()
            
        }
        
    }
    
    clearAllFields() {
        
        // 1. Reset Text Fields and Text Areas
        this.procurementTitleTextField.text = ""
        this.procurementGeneralDescriptionTitleTextArea.text = ""
        this.cpvCodeTextField.text = ""
        this.estimatedCostTextField.text = ""
        this.submissionDeadlineTextField.text = ""
        this.lessThanOffersTextField.text = ""
        this.extendDeadlineDaysTextField.text = ""
        
        // 2. Reset Checkboxes to unchecked (NO)
        this.autoExtendProcurementCheckbox.selected = NO
        this.hankeosadCheckbox.selected = NO
        
        // 3. Reset conditional field states
        // If the auto-extend checkbox is unchecked, these fields should be disabled
        this.lessThanOffersTextField.enabled = NO
        this.extendDeadlineDaysTextField.enabled = NO
        
        // 4. Reset Button Groups to their default values
        // Default for procurement type is "newProcurement" (based on initialization: selected: YES)
        this.procurementTypeButtonGroup.value = "newProcurement"
        
        // Default for duration is "specifiedInDocs" (based on initialization: selected: YES)
        this.contractDurationButtonGroup.value = "specifiedInDocs"
        
        // 5. Reset the static procurement property
        // This ensures that the next "save" creates a new procurement record rather than
        // attempting to update the one that was just cleared.
        NewProcurementViewController.procurement = undefined
        
    }
    
    
    override async handleRoute(route: UIRoute) {
        
        super.handleRoute(route)
        const inquiryComponent = route.componentWithName(NewProcurementViewController.routeComponentName)
        
    }
    
    
    override updateViewStyles() {
        super.updateViewStyles()
    }
    
    
    override layoutViewSubviews() {
        
        super.layoutViewSubviews()
        
        const padding = this.core.paddingLength
        const labelHeight = padding * 2
        
        // View bounds
        const bounds = this.view.bounds.rectangleWithInset(padding)
        
        this.titleLabel.frame = bounds.rectangleWithHeight(labelHeight * 2)
        
        this.titleLabel.frame.rectangleForNextRow(padding * 2, labelHeight)
            .distributeViewsEquallyAlongWidth([this.newProcurementTypeButton, this.frameProcurementTypeButton], padding)
            .rectangleForNextRow(padding)
            .distributeViewsEquallyAlongWidth([this.tiedProcurementTypeButton, this.copyProcurementTypeButton], padding)
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth([this.procurementTitleLabel], 0)
            .rectangleForNextRow(padding * 0.25, labelHeight)
            .distributeViewsEquallyAlongWidth([this.procurementTitleTextField], 0)
            
            
            .rectangleForNextRow(padding * 2)
            .distributeViewsEquallyAlongWidth([this.generalProcurementInformationSectionTitleLabel], 0)
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth([this.procurementGeneralDescriptionTitleLabel], 0)
            .rectangleForNextRow(padding * 0.25, labelHeight * 3)
            .distributeViewsEquallyAlongWidth([this.procurementGeneralDescriptionTitleTextArea], 0)
            
            
            .rectangleForNextRow(padding * 2, labelHeight)
            .distributeViewsEquallyAlongWidth([this.durationSectionTitleLabel], 0)
            .rectangleForNextRow(padding * 2, labelHeight)
            .distributeViewsEquallyAlongWidth(
                [this.durationSpecifiedInDocsButton, this.durationInMonthsButton],
                padding
            )
            .rectangleForNextRow(padding)
            .distributeViewsEquallyAlongWidth([this.durationInDaysButton, this.durationAsDateRangeButton], padding)
            
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth([this.cpvCodeTitleLabel], 0)
            .rectangleForNextRow(padding * 0.25, labelHeight)
            .distributeViewsEquallyAlongWidth([this.cpvCodeTextField], 0)
            .rectangleForNextRow(padding * 0.25, labelHeight)
            .distributeViewsEquallyAlongWidth([this.openCPVTreeButton, this.cpvTreeButtonExplanationLabel], padding)
            .rectangleForNextRow(padding * 0.25, labelHeight)
            .distributeViewsEquallyAlongWidth([
                this.openListOfInvitedOfferersButton,
                this.listOfInvitedOfferersButtonExplanationLabel
            ], padding)
            
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth([this.estimatedCostTitleLabel], 0)
            .rectangleForNextRow(padding * 0.25, labelHeight)
            .distributeViewsEquallyAlongWidth([this.estimatedCostTextField], 0)
            
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth([this.submissionDeadlineTitleLabel], 0)
            .rectangleForNextRow(padding * 0.25, labelHeight)
            .distributeViewsEquallyAlongWidth([this.submissionDeadlineTextField], 0)
            
            // layout for automatic extension rule
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth(
                [
                    this.autoExtendProcurementCheckbox,
                    this.lessThanOffersTextField,
                    this.autoExtendProcurementMiddleLabel,
                    this.extendDeadlineDaysTextField,
                    this.autoExtendProcurementEndLabel
                ],
                padding * 0.25
            )
            
            
            .rectangleForNextRow(padding * 2, labelHeight)
            .distributeViewsEquallyAlongWidth([this.hankeosadSectionTitleLabel], 0)
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth([this.hankeosadCheckbox], 0)
            
            
            .rectangleForNextRow(padding, labelHeight)
            .distributeViewsEquallyAlongWidth([this.nextButton], 0)
        
        
    }
    
    
}
